module.exports = __webpack_public_path__ + "img/bg34.afd69842.png";